<div class="add-object-tree" *ngIf="showTree">
  <div class="tree-node">
    <mat-radio-group aria-labelledby="radio-group-label" class="radio-group" [(ngModel)]="selectedBldg">
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="object-tree">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
          <ul>
            <li class="mat-tree-node">
              <mat-radio-button [value]="node.guid">
                <div class="name">
                  <div class="col1">
                    {{ node.buildingName }}
                  </div>
                </div>
                <div class="address">
                  <div class="col2-1">
                    <span class="fa fa-map-marker"></span>
                  </div>
                  <div class="col2-2">
                    {{ node | getAddress }}
                  </div>
                </div>
              </mat-radio-button>
            </li>
          </ul>
        </mat-tree-node>
        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodeToggle>
          <ul>
            <li>
              <div class="mat-tree-node" matTreeNodeToggle>
                <span
                  class="fa expand-icon"
                  [ngClass]="{
                    'fa-chevron-down': treeControl.isExpanded(node),
                    'fa-chevron-right': !treeControl.isExpanded(node)
                  }"
                >
                  <label>{{ node.buildingTypeName }}</label></span
                >
              </div>
              <ul [class.object-tree-invisible]="!treeControl.isExpanded(node)">
                <ng-container matTreeNodeOutlet></ng-container>
              </ul>
            </li>
          </ul>
        </mat-nested-tree-node>
      </mat-tree>
    </mat-radio-group>
  </div>

  <div class="apply-button" *ngIf="this.buildingsWithoutEA.length > 0">
    <button class="btn btn-outline-primary" (click)="openQuestionnaire(selectedBldg)" [disabled]="getButtonStatus()">
      {{ 'module.efficiencyAnalysis.addObject.applyButtonText' | translate }}
    </button>
  </div>

  <div *ngIf="showQuestionnaire" class="overlay">
    <app-building-efficiency-wizard
      class="building-efficiency-wizard"
      [buildingZipcode]="selectedBuilding.zipCode"
      [buildingGuid]="selectedBuilding.guid"
      [visibility]="showQuestionnaire"
      (closeEvent)="closeQuestionnaire($event)"
      (saveEmitter)="saveEfficiencyAnalysis()"
    >
    </app-building-efficiency-wizard>
  </div>
</div>
